import React from 'react';
import { MdArrowBack, MdArrowUpward, MdArrowDownward, MdRemove } from 'react-icons/md';

// Static rate snapshot — easy to swap to a /api/rates endpoint later.
// Direction tokens drive the up/down arrow + color in the JSX.
const RATE_GROUPS = [
  {
    label: 'Mortgages',
    rows: [
      { name: '5-year fixed',     rate: '5.99%', change: '+0.10%', direction: 'up'   },
      { name: '5-year variable',  rate: '5.45%', change: '−0.05%', direction: 'down' },
      { name: '3-year fixed',     rate: '5.79%', change: '0.00%',  direction: 'flat' },
      { name: '1-year fixed',     rate: '6.15%', change: '+0.05%', direction: 'up'   },
    ],
  },
  {
    label: 'Savings',
    rows: [
      { name: 'High Interest Savings', rate: '3.50%', change: '0.00%',  direction: 'flat' },
      { name: 'TFSA savings',          rate: '3.25%', change: '+0.10%', direction: 'up'   },
      { name: 'GIC — 1 year',          rate: '4.10%', change: '−0.15%', direction: 'down' },
      { name: 'GIC — 5 year',          rate: '4.45%', change: '+0.05%', direction: 'up'   },
    ],
  },
  {
    label: 'Foreign Exchange',
    rows: [
      { name: 'CAD → USD', rate: '0.7325', change: '+0.0012', direction: 'up'   },
      { name: 'CAD → EUR', rate: '0.6748', change: '−0.0008', direction: 'down' },
      { name: 'CAD → GBP', rate: '0.5812', change: '+0.0021', direction: 'up'   },
      { name: 'CAD → JPY', rate: '110.84', change: '−0.42',   direction: 'down' },
    ],
  },
];

const directionColor = {
  up:   'var(--td-green)',
  down: 'var(--td-red)',
  flat: 'var(--bh-gray)',
};
const DirectionIcon = ({ direction }) => {
  if (direction === 'up')   return <MdArrowUpward size={14} />;
  if (direction === 'down') return <MdArrowDownward size={14} />;
  return <MdRemove size={14} />;
};

const TodaysRatesScreen = ({ onNavigate, onBack }) => {
  const today = new Date().toLocaleDateString('en-CA', { weekday: 'long', month: 'long', day: 'numeric' });

  return (
    <div className="screen bh-flow">
      <header className="bh-flow-hero">
        <div className="bh-flow-hero-left">
          <button className="bh-flow-back" onClick={onBack || (() => onNavigate('services'))} aria-label="Back to services">
            <MdArrowBack />
          </button>
          <h1 className="bh-flow-title">Today's Rates</h1>
        </div>
      </header>

      <div className="bh-flow-body">
        <div className="bh-form-card" style={{ alignItems: 'center', gap: 'var(--space-2xs)' }}>
          <span style={{ font: 'var(--bh-overline)', textTransform: 'uppercase', color: 'var(--bh-gray)' }}>
            As of
          </span>
          <span style={{ font: 'var(--bh-h3)', color: 'var(--bh-black)' }}>{today}</span>
          <span style={{ font: 'var(--bh-caption)', color: 'var(--bh-gray)' }}>
            Snapshots refresh daily. Talk to an advisor for live quotes.
          </span>
        </div>

        {RATE_GROUPS.map(group => (
          <section key={group.label}>
            <h2 className="bh-section-title" style={{ paddingLeft: 0 }}>{group.label}</h2>
            <div className="bh-recent-list">
              {group.rows.map(r => (
                <div key={r.name} className="bh-recent-row" style={{ cursor: 'default' }}>
                  <div className="bh-recent-row-info">
                    <span className="bh-recent-row-name">{r.name}</span>
                  </div>
                  <div className="bh-recent-row-meta">
                    <span className="bh-recent-row-amount">{r.rate}</span>
                    <span
                      className="bh-recent-row-status"
                      style={{ display: 'inline-flex', alignItems: 'center', gap: 4, color: directionColor[r.direction] }}
                    >
                      <DirectionIcon direction={r.direction} />
                      {r.change}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </section>
        ))}
      </div>
    </div>
  );
};

export default TodaysRatesScreen;
